import { InjectionToken } from '@angular/core';
import { SharedConfig } from './shared-config.interface';

export const SHARED_CONFIG = new InjectionToken<SharedConfig>('SHARED_CONFIG');
